import { createPersistedStatePlugin } from "pinia-plugin-persistedstate-2";
import stringify from "json-stringify-safe";
import type { Pinia, PiniaPluginContext } from "pinia";
import omit from "lodash-es/omit";
import { getStoreInstance } from "@/composables/localforage";

export default defineNuxtPlugin((nuxtApp) => {
  const storage = getStoreInstance(
    "state",
    "support-sync-pinia-store",
    "This is the local forage state representation of pinia in memory state",
  );

  (nuxtApp.$pinia as Pinia).use((context: PiniaPluginContext) => {
    const installPlugin = createPersistedStatePlugin({
      serialize: (state) => {
        return stringify(state);
      },
      storage: {
        getItem(key) {
          return storage.getItem(key);
        },
        ...omit(storage, ["getItem"]),
      },
    });

    return installPlugin(context);
  });
});
